import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { ConsoleLogger, getId } from '@aws-amplify/core';
import { AuthError } from '../../../errors/AuthError.mjs';
import { getRegionFromIdentityPoolId } from '../utils/clients/CognitoIdentityProvider/utils.mjs';
import { formLoginsMap } from './utils.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var logger = new ConsoleLogger('CognitoIdentityIdProvider');
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */

function cognitoIdentityIdProvider(_x) {
  return _cognitoIdentityIdProvider.apply(this, arguments);
}

function _cognitoIdentityIdProvider() {
  _cognitoIdentityIdProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var tokens, authConfig, identityIdStore, identityId, logins, generatedIdentityId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokens = _ref.tokens, authConfig = _ref.authConfig, identityIdStore = _ref.identityIdStore;
            identityIdStore.setAuthConfig({
              Cognito: authConfig
            }); // will return null only if there is no identityId cached or if there is an error retrieving it

            _context.next = 4;
            return identityIdStore.loadIdentityId();

          case 4:
            identityId = _context.sent;

            if (!tokens) {
              _context.next = 18;
              break;
            }

            if (!(identityId && identityId.type === 'primary')) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", identityId.id);

          case 10:
            logins = tokens.idToken ? formLoginsMap(tokens.idToken.toString()) : {};
            _context.next = 13;
            return generateIdentityId(logins, authConfig);

          case 13:
            generatedIdentityId = _context.sent;

            if (identityId && identityId.id === generatedIdentityId) {
              logger.debug("The guest identity ".concat(identityId.id, " has become the primary identity."));
            }

            identityId = {
              id: generatedIdentityId,
              type: 'primary'
            };

          case 16:
            _context.next = 26;
            break;

          case 18:
            if (!(identityId && identityId.type === 'guest')) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", identityId.id);

          case 22:
            _context.next = 24;
            return generateIdentityId({}, authConfig);

          case 24:
            _context.t0 = _context.sent;
            identityId = {
              id: _context.t0,
              type: 'guest'
            };

          case 26:
            // Store in-memory or local storage depending on guest or primary identityId
            identityIdStore.storeIdentityId(identityId);
            return _context.abrupt("return", identityId.id);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cognitoIdentityIdProvider.apply(this, arguments);
}

function generateIdentityId(_x2, _x3) {
  return _generateIdentityId.apply(this, arguments);
}

function _generateIdentityId() {
  _generateIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(logins, authConfig) {
    var identityPoolId, region, idResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            identityPoolId = authConfig === null || authConfig === void 0 ? void 0 : authConfig.identityPoolId;
            region = getRegionFromIdentityPoolId(identityPoolId); // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API

            _context2.next = 4;
            return getId({
              region: region
            }, {
              IdentityPoolId: identityPoolId,
              Logins: logins
            });

          case 4:
            idResult = _context2.sent.IdentityId;

            if (idResult) {
              _context2.next = 7;
              break;
            }

            throw new AuthError({
              name: 'GetIdResponseException',
              message: 'Received undefined response from getId operation',
              recoverySuggestion: 'Make sure to pass a valid identityPoolId in the configuration.'
            });

          case 7:
            return _context2.abrupt("return", idResult);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _generateIdentityId.apply(this, arguments);
}

export { cognitoIdentityIdProvider };